import {
  Button,
  Emphasis,
} from "@lya-protect/lya-protect-form-library/dist/UI";
import "./landing.scss";
import { PopperButton } from "@src/PopperButton";
import { InfoBulleButton } from "@src/components/infoBulleButton/InfoBulleButton";
import { InfoBulle } from "@src/components/infoBulle/InfoBulle";
import { ReactComponent as CheckCircle } from "@src/svg/check-circle.svg";
import { StepProps } from "../../step/Steps";

export type LandingData = undefined;
type LandingProps = StepProps<LandingData>;

export function Landing({ changeStep }: LandingProps) {
  return (
    <div className="landing-step">
      <div className="stepper__centered-container landing-step__first-part">
        <div className="stepper__centered-content step__grid">
          <h1>
            {"Le contrat Pavixie vous couvre et vous accompagne "}
            <Emphasis>
              en cas d&apos;accident de la vie courante * ou en cas de décès
              accidentel
            </Emphasis>
          </h1>
          <ul className="landing-step__check-list">
            <li>
              <CheckCircle className="landing-step__check-list-svg" />
              <p> Accessible au plus grand nombre de 0 à 75 ans.</p>
            </li>

            <li>
              <CheckCircle className="landing-step__check-list-svg" />
              Percevez une indemnité de 500 € à 1 500 € par pourcentage
              d&apos;AIPP
              <PopperButton
                popperPlacement="top-start"
                openOnHover
                withArrow
                renderButton={(props) => <InfoBulleButton {...props} />}
                renderPopperContent={({ setVisible }) => (
                  <InfoBulle
                    className="landing-step__infobulle"
                    onCancel={() => setVisible(false)}
                  >
                    Le taux d&apos;atteinte à l&apos;intégrité physique et
                    psychique(AIPP) est le préjudice lié à la réduction du
                    potentiel physique, psychosensoriel et intellectuel. Il
                    s&apos;agit des séquelles résultant d&apos;un accident. Ce
                    taux est calculé par un médecin expert une fois la
                    consolidation acquise.
                  </InfoBulle>
                )}
              />
              en cas d’accident de la vie courante
              <PopperButton
                popperPlacement="top-start"
                openOnHover
                withArrow
                renderButton={(props) => <InfoBulleButton {...props} />}
                renderPopperContent={({ setVisible }) => (
                  <InfoBulle
                    className="landing-step__infobulle"
                    onCancel={() => setVisible(false)}
                  >
                    Toute atteinte à l&apos;intégrité physique et/ou psychique
                    du membre participant non intentionnelle de sa part,
                    provenant de l&apos;action soudaine, imprévisible, brutale,
                    directe et exclusive d&apos;une cause extérieure, étrangère
                    à sa volonté survenue dans le cadre d&apos;une activité
                    domestique touristique, de loisir ou sportive autre
                    qu&apos;exclue contractuellement.
                  </InfoBulle>
                )}
              />
              , selon le niveau d&apos;indemnisation souscrit.
            </li>

            <li>
              <CheckCircle className="landing-step__check-list-svg" />
              Allocation temporaire décès de 60 000 € à 180 000 € versée au(x)
              bénéficiaires(s) désigné(s) en cas de décès accidentel
              <PopperButton
                popperPlacement="top-end"
                openOnHover
                withArrow
                renderButton={(props) => <InfoBulleButton {...props} />}
                renderPopperContent={({ setVisible }) => (
                  <InfoBulle
                    className="landing-step__infobulle"
                    onCancel={() => setVisible(false)}
                  >
                    <p>
                      Lorsque la causalité accidentelle est directe, certaine et
                      déterminante, résultant d&apos;une cause extérieure
                      imprévisible.
                    </p>
                  </InfoBulle>
                )}
              />
              du membre participant survenu jusqu’à ses 67 ans au plus, selon le
              niveau d&apos;indemnisation souscrit.
            </li>

            <li>
              <CheckCircle className="landing-step__check-list-svg" />
              Dès l&apos;adhésion, bénéficiez de l&apos;accès aux garanties
              d&apos;assistance assurées et réalisées par Ressources Mutuelles
              Assistance
              <PopperButton
                popperPlacement="top-end"
                openOnHover
                withArrow
                renderButton={(props) => <InfoBulleButton {...props} />}
                renderPopperContent={({ setVisible }) => (
                  <InfoBulle
                    className="landing-step__infobulle"
                    onCancel={() => setVisible(false)}
                  >
                    <p>
                      Les garanties d&apos;assistance au contrat Paxivie sont
                      assurées et réalisées par Ressources Mutuelles Assistance,
                      union d&apos;assistance soumise aux dispositions du Livre
                      II du Code de la mutualité, dont le siège social est situé
                      au 46 rue du Moulin - CS 92443, 44120 Vertou et
                      immatriculée sous le numéro Siren 444 269 682.
                    </p>
                  </InfoBulle>
                )}
              />
              . Certaines sont accessibles en cas d&apos;immobilisation, de
              reconnaissance d&apos;une situation de handicap ou encore en cas
              de décès pour soulager vos proches.
            </li>
          </ul>
          <div className="step__grid-bloc">
            <h2>Laissez-vous guider !</h2>
            <div className="landing-step__progress">
              <div className="landing-step__progress-item">
                <div className="landing-step__progress-top">
                  <span>01</span>
                  <div />
                </div>
                <p className="landing-step__progress-name">
                  Obtenez votre tarif
                </p>
              </div>
              <div className="landing-step__progress-item">
                <div className="landing-step__progress-top">
                  <span>02</span>
                  <div />
                </div>
                <p className="landing-step__progress-name">
                  Recevez votre devis par mail
                </p>
              </div>
              <div className="landing-step__progress-item">
                <div className="landing-step__progress-top">
                  <span>03</span>
                </div>
                <p className="landing-step__progress-name">
                  Souscrivez en ligne
                </p>
              </div>
            </div>
          </div>

          <Button onClick={() => changeStep("SITUATION", "forward")}>
            Je démarre
          </Button>

          <div className="step__grid-bloc">
            <small>
              <Emphasis>{"* "}</Emphasis>
              Prise en charge dès 1% d&apos;AIPP (Atteinte à l&apos;Intégrité
              Physique et Psychique consolidée)
            </small>
          </div>
        </div>
      </div>
    </div>
  );
}
